"use client";

import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  Button,
} from "@oreme/ui";
import { useAtom } from "jotai";
import { MapPin, ChevronRight } from "lucide-react";
import { useMap } from "maplibre-react-components";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { SitesRegionSearch } from "@/components";
import { sidebarFilterLocationVisibilityAtom } from "@/store/sites";

function SitesSidebarFilterLocation(): ReactElement {
  const t = useTranslations("sites.SidebarFilterLocation");
  const map = useMap("map");
  const [isVisible, toggleVisibility] = useAtom(
    sidebarFilterLocationVisibilityAtom,
  );

  const handleAroundMe = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          map?.flyTo({
            center: [position.coords.longitude, position.coords.latitude],
            zoom: 10,
          });
        },
        (err) => console.log(err.message),
      );
    }
  };

  const handleMontpellier = () => {
    map?.flyTo({
      center: [3.8741693, 43.6100162],
      zoom: 10,
    });
  };

  const handleFrance = () => {
    map?.flyTo({
      center: [2.5911028, 46.1106885],
      zoom: 5,
    });
  };

  const handleWorld = () => {
    map?.flyTo({ center: [0, 0], zoom: 1 });
  };

  return (
    <Collapsible
      className="group/collapsible p-0 border rounded-lg"
      id="tour-5"
      open={isVisible}
      onOpenChange={toggleVisibility}
    >
      <div key="location">
        <CollapsibleTrigger asChild>
          <Button
            variant="ghost"
            className="flex flex-row gap-1 border-0 bg-transparent"
            onClick={() => toggleVisibility()}
            asChild
          >
            <span className="flex flex-row gap-1">
              <MapPin />
              <span>{t("location")}</span>
              <ChevronRight
                className={`ml-auto h-4 w-4 transition-transform ${isVisible ? "rotate-90" : ""}`}
              />
            </span>
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="flex flex-col gap-2 p-2">
          <SitesRegionSearch />
          <div className="flex flex-col gap-1">
            <div className="flex flex-row gap-1">
              <Button
                className="flex-1"
                onClick={() => handleWorld()}
                size="sm"
                variant="secondary"
              >
                {t("world")}
              </Button>
              <Button
                className="flex-1"
                onClick={() => handleFrance()}
                size="sm"
                variant="secondary"
              >
                {t("france")}
              </Button>
              <Button
                className="flex-1"
                onClick={() => handleMontpellier()}
                size="sm"
                variant="secondary"
              >
                {t("montpellier")}
              </Button>
            </div>
            <Button
              onClick={() => handleAroundMe()}
              size="sm"
              variant="secondary"
            >
              {t("aroundMe")}
            </Button>
          </div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}

export { SitesSidebarFilterLocation };
